import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BadgeModule } from '../badge/badge.module';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs.component';

@NgModule({
  declarations: [TabComponent, TabsComponent],
  exports: [TabComponent, TabsComponent],
  imports: [BadgeModule, CommonModule],
})
export class TabsModule {}
export { TabComponent } from './tab/tab.component';
export { TabsComponent } from './tabs.component';
